import Create from '@/views/rh/contrat/pages/ContratCreate';
import Edit from '@/views/rh/contrat/pages/ContratEdit';
import Show from '@/views/rh/contrat/pages/ContratShow';

export default [
  {
    path: '/rh/employe/contrat/create/:filter?/:id?/:employeId/:prov',
    name: 'rh_employe_contrat-create',
    component: Create,
    meta: {
      auth: true,
      module: 'rh',
      permission: 'create contrat',
    },
  },
  {
    path: '/rh/employe/contrat/edit/:id/:employeId/:prov',
    name: 'rh_employe_contrat-edit',
    component: Edit,
    meta: {
      auth: true,
      module: 'rh',
      permission: 'edit contrat',
    },
  },
  {
    path: '/rh/employe/contrat/show/:id/:employeId/:prov',
    name: 'rh_employe_contrat-show',
    component: Show,
    meta: {
      auth: true,
      module: 'rh',
      permission: 'view contrat',
    },
  },
];
